import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/errors',
        pathMatch: 'full',
    },
    {
        path: 'public/kiosk/:companyId',
        loadChildren: () => import('./pages/kiosk/kiosk.module').then(m => m.KioskModule),
    },
    {
        path: 'public/payment/reservation/:reservationId/guest/:guestId',
        loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule),
    },
    {
        path: ':env/public/:reservationId/register',
        loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule),
    },
    {
        path: 'public/:reservationId/register',
        loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule),
    },
    {
        path: ':env/public/:reservationId/manifests',
        redirectTo: ':reservationId/manifest',
    },
    {
        path: 'public/:reservationId/manifests',
        redirectTo: ':reservationId/manifest',
    },
    {
        path: ':reservationId/manifest',
        loadChildren: () => import('./pages/manifests/manifests.module').then(m => m.ManifestsModule),
    },
    {
        path: 'errors',
        loadChildren: () => import('./pages/errors/errors.module').then(m => m.ErrorsModule),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules,
            paramsInheritanceStrategy: 'always',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
